<template>
  <div>
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark"><i class="nav-icon fas fa-tachometer-alt"></i> Dashboard</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link to="/dashboard">
                  <i class="nav-icon fas fa-home"></i> Home
                </router-link>
              </li>
              <li class="breadcrumb-item active"><i class="nav-icon fas fa-tachometer-alt"></i> Dashboard</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-3 col-6">
            <!-- small box -->
            <div class="small-box bg-success">
              <div class="inner">
                <h3>{{ contactsStatus.normal }}</h3>
                <p>Usuários em Segurança</p>
              </div>
              <div class="icon">
                <i class="fas fa-thumbs-up"></i>
              </div>
              <router-link
                :to="{ name: 'list-user', query: { emergencyStatus: 0 } }"
                class="small-box-footer"
              >
                Ver Todos <i class="fas fa-arrow-circle-right"></i>
              </router-link>
            </div>
          </div>
          <!-- ./col -->
          <div class="col-lg-3 col-6">
            <!-- small box -->
            <div class="small-box bg-warning">
              <div class="inner">
                <h3>{{ contactsStatus.alerta }}</h3>
                <p>Usuários em Alerta</p>
              </div>
              <div class="icon">
                <i class="fas fa-exclamation-triangle"></i>
              </div>
              <router-link
                :to="{ name: 'list-user', query: { emergencyStatus: 1 } }"
                class="small-box-footer"
              >
                Ver Todos <i class="fas fa-arrow-circle-right"></i>
              </router-link>
            </div>
          </div>
          <!-- ./col -->            
          <div class="col-lg-3 col-6">
            <!-- small box -->
            <div class="small-box bg-danger">
              <div class="inner">
                <h3>{{ contactsStatus.panico }}</h3>
                <p>Usuários em Pânico</p>
              </div>
              <div class="icon">
                <i class="fas fa-siren"></i>
              </div>
              <router-link
                :to="{ name: 'list-user', query: { emergencyStatus: 2 } }"
                class="small-box-footer"
              >
                Ver Todos <i class="fas fa-arrow-circle-right"></i>
              </router-link>
            </div>
          </div>
          <!-- ./col -->
            <div class="col-lg-3 col-6">
            <!-- small box -->
            <div class="small-box bg-secondary">
              <div class="inner">
                <h3>{{ contactsStatus.emergencia }}</h3>
                <p>Usuários em Emergência Médica</p>
              </div>
              <div class="icon">
                <i class="fas fa-star-of-life"></i>
              </div>
              <router-link
                :to="{ name: 'list-user', query: { emergencyStatus: 3 } }"
                class="small-box-footer"
              >
                Ver Todos <i class="fas fa-arrow-circle-right"></i>
              </router-link>
            </div>
          </div>
          <!-- ./col -->
        </div>
        <div class="card card-danger card-outline">
          <div class="card-header">
              <h3 class="card-title"> Listagem de Usuários em Pânico</h3>
              <div class="card-tools">
                  <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
                      <i class="fas fa-minus"></i>
                  </button>
                  <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
                      <i class="fas fa-times"></i>
                  </button>
              </div>
          </div>
          <div class="card-body ">
            <div class="row text-success" v-if="panicList.length == 0">
              <i class="fas fa-lg fa-thumbs-up"></i> Nenhum usuário em pânico no momento.
            </div>
            <div class="row" v-if="panicList.length > 0">
              <div class="col-12 col-sm-6 col-md-3 d-flex align-items-stretch flex-column" v-for="(panic, index) in panicList" :key="index">
                <div class="card bg-light d-flex flex-fill">
                  <div class="card-header text-danger border-bottom-0">
                    <i class="fas fa-siren blink_me"></i> Em Pânico
                  </div>
                  <div class="card-body pt-0">
                    <div class="row">
                      <div class="col-8">
                        <h2 class="lead"><b>{{panic.name}}</b></h2>
                        <ul class="ml-4 mb-0 fa-ul text-muted">
                          <li class="small"><span class="fa-li"><i class="far fa-envelope"></i></span> E-mail: {{ panic.email }}</li>
                          <li class="small" v-if="panic.telefone"><span class="fa-li"><i class="fas fa-phone"></i></span> Telefone: {{ panic.telefone }}</li>
                          <li class="small" v-if="panic.device_imei1"><span class="fa-li"><i class="far fa-microchip"></i></span> IMEI 1: {{ panic.device_imei1 }}</li>
                          <li class="small" v-if="panic.device_imei2"><span class="fa-li"><i class="far fa-microchip"></i></span> IMEI 2: {{ panic.device_imei2 }}</li>
                          <li class="small" v-if="panic.device_ip"><span class="fa-li"><i class="far fa-router"></i></span> IP: {{ panic.device_ip }}</li>
                          <li class="small" v-if="panic.device_model"><span class="fa-li"><i class="fas fa-mobile-alt"></i></span> Modelo do Celular: {{ panic.device_model }}</li>
                        </ul>
                      </div>
                      <div class="col-4 text-center">
                        <img :src="panic.foto" alt="user-avatar" class="img-circle img-fluid">
                      </div>
                    </div>
                  </div>
                  <div class="card-footer">
                    <div class="text-center">
                      <router-link
                      :to="{ name: 'view-user', params: { id: panic.id_user } }"
                      class="btn btn-sm btn-primary"
                      >
                        <i class="fas fa-user"></i> Ver Profile
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.card-body -->
          <div class="card-footer">
          </div>
          <!-- /.card-footer -->
        </div>
      </div>
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
import UserController from "@/controllers/user.controller";

export default {
  name: "Dashboard",
  components: {

  },
  data () {
    return {
      contactsStatus: {
        normal: 0,
        alerta: 0,
        panico: 0,
        emergencia: 0
      },
      panicList: {},
      intervalId: null
    }
  },
  mounted() {
    this.getContactsStatus();
    this.intervalId = setInterval(() => {
      this.getContactsStatus();
    }, 5000);
  },
  beforeDestroy() { // <- Vue 2 usa este hook
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  },
  methods: {
    getContactsStatus: function () {
      UserController.getContactsStatus()
      .then(response => {
        if (!response)
          return;
        this.contactsStatus = response.data.result;
      });

      UserController.getPanicAlert()
      .then(response => {
        if (!response)
          return;
        this.panicList = response.data.result;
      });
    }
  }
}
</script>

<style scoped>
</style>